// Central site content & package data for Life Line Tours and Travels

export const COMPANY = {
  name: "Life Line Tours and Travels",
  legal: "Life Line Tours and Travels Pvt Ltd",
  tagline: "Creating Memories Since 1991",
  since: 1991,
  logo: "/brand/logo.webp",
  phones: ["+91 98909 16767", "+91 88052 06767"],
  whatsapp: "919890916767",
  email: "operations@lifelinetravels.in",
  altEmail: "lifelinett@yahoo.com",
  address:
    "Flat No. 2, Saraswati Apartment, Opposite Sinhgad Institute, near Kwality Family Resto Bar, Erandwane, Pune, Maharashtra 411004",
  social: {
    facebook: "https://www.facebook.com/lifelinett",
    instagram: "https://www.instagram.com/lifelinetourstravels/",
  },
  mapEmbed:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3783.9!2d73.82!3d18.50!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2sErandwane%2C%20Pune!5e0!3m2!1sen!2sin!4v1700000000000",
};

export const STATS = [
  { value: 35, suffix: "+", label: "Years of Excellence" },
  { value: 3000, suffix: "+", label: "Travellers Every Year" },
  { value: 500, suffix: "+", label: "Curated Tours" },
  { value: 40, suffix: "+", label: "Destinations Covered" },
];

export const CERTIFICATIONS = [
  "Ministry of Tourism, India",
  "Incredible India",
  "ETAA Member",
  "Govt. Approved Study Tours",
];

export const CERT_LOGOS = [
  {
    name: "Ministry of Tourism, Government of India",
    url: "/brand/ministry-of-tourism.png",
  },
  {
    name: "Incredible India",
    url: "/brand/incredible-india.png",
  },
  {
    name: "ETAA - Enterprising Travel Agents Association",
    url: "/brand/etaa.jpg",
  },
];

const IMG = {
  himalaya: "https://images.pexels.com/photos/34775561/pexels-photo-34775561.jpeg",
  tropical: "https://images.pexels.com/photos/28542403/pexels-photo-28542403.jpeg",
  nepal: "https://images.pexels.com/photos/32132398/pexels-photo-32132398.jpeg",
  andaman:
    "https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  rajasthan:
    "https://images.unsplash.com/photo-1591946522651-90fbace43004?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  corporate:
    "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  vietnam:
    "https://images.unsplash.com/photo-1528127269322-539801943592?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  spiti:
    "https://images.unsplash.com/photo-1626621341517-bbf3d9990a23?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  bhutan:
    "https://images.unsplash.com/photo-1553856622-d1b352e9a211?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  srilanka:
    "https://images.unsplash.com/photo-1566296314736-6eaac1ca0cb9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  kailash:
    "https://images.unsplash.com/photo-1585516482825-56c1a3b01ea9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  chardham:
    "https://images.pexels.com/photos/32132398/pexels-photo-32132398.jpeg",
  farm:
    "https://images.unsplash.com/photo-1500937386664-56d1dfef3854?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  planning:
    "https://images.unsplash.com/photo-1488646953014-85cb44e25828?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const HERO_IMAGES = [IMG.himalaya, IMG.tropical, IMG.rajasthan, IMG.andaman, IMG.vietnam, IMG.nepal];

const defaultInc = [
  "Accommodation in handpicked hotels/resorts",
  "Daily breakfast and dinner as per itinerary",
  "Private air-conditioned transport",
  "Experienced tour manager / local guide",
  "All sightseeing and entry tickets mentioned",
  "All applicable toll, parking and driver charges",
];
const defaultExc = [
  "Airfare / train fare unless specified",
  "Lunch and personal expenses",
  "Monument camera charges & adventure activities",
  "GST and TCS as applicable",
  "Anything not mentioned under inclusions",
];

export const PACKAGES = [
  {
    slug: "marvellous-two-sisters",
    title: "Marvellous Two Sisters",
    subtitle: "Sikkim & Darjeeling",
    region: "North East",
    type: "domestic",
    price: 39500,
    nights: 6,
    days: 7,
    tag: "Bestseller",
    image: IMG.nepal,
    summary:
      "Ride the toy train through misty tea gardens, wake to Kanchenjunga at dawn and lose yourself in the emerald valleys of Sikkim and Darjeeling.",
    highlights: ["Tiger Hill sunrise", "Tsomgo Lake", "Nathula Pass", "Darjeeling toy train"],
    itinerary: [
      { day: 1, title: "Arrive Gangtok", desc: "Meet & greet at NJP, scenic drive to Gangtok, evening at leisure on MG Marg." },
      { day: 2, title: "Gangtok Local & Tsomgo Lake", desc: "Excursion to the glacial Tsomgo Lake and Baba Mandir with Nathula Pass option." },
      { day: 3, title: "Gangtok to Pelling", desc: "Drive to Pelling visiting waterfalls and the historic Pemayangtse Monastery." },
      { day: 4, title: "Pelling to Darjeeling", desc: "Transfer to the Queen of Hills, evening stroll at Mall Road." },
      { day: 5, title: "Tiger Hill Sunrise", desc: "Early sunrise at Tiger Hill, Batasia Loop, Himalayan Zoo and tea estates." },
      { day: 6, title: "Leisure & Toy Train", desc: "Joy ride on the UNESCO toy train and local shopping." },
      { day: 7, title: "Departure", desc: "Transfer to NJP / Bagdogra with cherished memories." },
    ],
  },
  {
    slug: "amazing-andaman",
    title: "Amazing Andaman",
    subtitle: "Port Blair • Havelock • Neil",
    region: "Islands",
    type: "domestic",
    price: 42700,
    nights: 5,
    days: 6,
    tag: "Beach Escape",
    image: IMG.andaman,
    summary:
      "Turquoise lagoons, powder-white sand and living coral reefs. The Andaman islands are India's most spectacular tropical secret.",
    highlights: ["Radhanagar Beach", "Cellular Jail light show", "Scuba at Havelock", "Bharatpur snorkelling"],
    itinerary: [
      { day: 1, title: "Arrive Port Blair", desc: "Cellular Jail visit and the emotive Light & Sound show." },
      { day: 2, title: "Ferry to Havelock", desc: "Cruise to Havelock, relax at the world-famous Radhanagar Beach." },
      { day: 3, title: "Havelock Water Sports", desc: "Scuba diving, snorkelling and beach leisure at Elephant Beach." },
      { day: 4, title: "Neil Island", desc: "Natural Bridge, Bharatpur and Laxmanpur beaches." },
      { day: 5, title: "Return to Port Blair", desc: "Chidiya Tapu sunset point and Corbyn's Cove." },
      { day: 6, title: "Departure", desc: "Transfer to airport." },
    ],
  },
  {
    slug: "majestic-rajasthan",
    title: "Majestic Rajasthan",
    subtitle: "Jaipur • Jodhpur • Udaipur",
    region: "Heritage",
    type: "domestic",
    price: 49700,
    nights: 7,
    days: 8,
    tag: "Royal",
    image: IMG.rajasthan,
    summary:
      "Live like royalty across the pink, blue and white cities — grand forts, mirrored palaces and shimmering desert lakes.",
    highlights: ["Amber Fort", "Mehrangarh", "Lake Pichola boat", "Desert culture"],
    itinerary: [
      { day: 1, title: "Arrive Jaipur", desc: "The Pink City welcome, evening at leisure." },
      { day: 2, title: "Jaipur Sightseeing", desc: "Amber Fort, Hawa Mahal, City Palace and Jantar Mantar." },
      { day: 3, title: "Jaipur to Jodhpur", desc: "Drive to the Blue City via Pushkar." },
      { day: 4, title: "Jodhpur", desc: "Towering Mehrangarh Fort and Jaswant Thada." },
      { day: 5, title: "Jodhpur to Udaipur", desc: "Enroute the majestic Ranakpur Jain temples." },
      { day: 6, title: "Udaipur", desc: "City Palace and a romantic boat ride on Lake Pichola." },
      { day: 7, title: "Leisure Udaipur", desc: "Saheliyon ki Bari and local bazaars." },
      { day: 8, title: "Departure", desc: "Transfer to airport." },
    ],
  },
  {
    slug: "spiti-valley",
    title: "Spiti Valley Expedition",
    subtitle: "Middle Land of Himalayas",
    region: "Himalaya",
    type: "domestic",
    price: 67700,
    nights: 8,
    days: 9,
    tag: "Adventure",
    image: IMG.spiti,
    summary:
      "A high-altitude desert of ancient monasteries, fossil villages and star-drenched skies — Spiti is a journey to the edge of the world.",
    highlights: ["Key Monastery", "Chandratal Lake", "Kaza & Kibber", "Fossil village Langza"],
    itinerary: [
      { day: 1, title: "Shimla Arrival", desc: "Arrive and acclimatise in the colonial hill capital." },
      { day: 2, title: "Shimla to Kalpa", desc: "Drive along the Sutlej valley to apple-orchard Kalpa." },
      { day: 3, title: "Kalpa to Tabo", desc: "Cross into Spiti, visit the 1000-year-old Tabo Monastery." },
      { day: 4, title: "Tabo to Kaza", desc: "Dhankar Monastery and the geyser village of Lhalung." },
      { day: 5, title: "Kaza Circuit", desc: "Key Monastery, Kibber, Langza fossils and Hikkim post office." },
      { day: 6, title: "Kaza to Chandratal", desc: "Camp beside the moon lake under a blanket of stars." },
      { day: 7, title: "Chandratal to Manali", desc: "Cross Kunzum & Rohtang passes to Manali." },
      { day: 8, title: "Manali Leisure", desc: "Explore Old Manali and Solang valley." },
      { day: 9, title: "Departure", desc: "Transfer for onward journey." },
    ],
  },
  {
    slug: "northeast-india",
    title: "Enchanting Northeast India",
    subtitle: "Meghalaya • Assam",
    region: "North East",
    type: "domestic",
    price: 74700,
    nights: 8,
    days: 9,
    tag: "Offbeat",
    image: IMG.himalaya,
    summary:
      "Living root bridges, the cleanest village in Asia and the crystal rivers of Meghalaya — the unspoilt soul of India's east.",
    highlights: ["Living Root Bridges", "Dawki river", "Mawlynnong", "Kaziranga safari"],
    itinerary: [
      { day: 1, title: "Arrive Guwahati", desc: "Kamakhya Temple and Brahmaputra sunset cruise." },
      { day: 2, title: "Guwahati to Kaziranga", desc: "Drive to the UNESCO rhino sanctuary." },
      { day: 3, title: "Kaziranga Safari", desc: "Morning jeep safari in search of one-horned rhinos." },
      { day: 4, title: "Kaziranga to Shillong", desc: "Scotland of the East via Umiam Lake." },
      { day: 5, title: "Cherrapunjee", desc: "Nohkalikai Falls, Mawsmai caves and viewpoints." },
      { day: 6, title: "Mawlynnong & Dawki", desc: "Asia's cleanest village and crystal-clear Dawki river." },
      { day: 7, title: "Living Root Bridges", desc: "Trek to the double-decker living root bridge." },
      { day: 8, title: "Return Guwahati", desc: "Leisure and shopping." },
      { day: 9, title: "Departure", desc: "Transfer to airport." },
    ],
  },
  {
    slug: "essence-of-vietnam",
    title: "Essence of Vietnam",
    subtitle: "Hanoi • Halong • Da Nang",
    region: "South East Asia",
    type: "international",
    price: 142700,
    nights: 7,
    days: 8,
    tag: "Popular",
    image: IMG.vietnam,
    summary:
      "Emerald limestone karsts of Halong Bay, lantern-lit Hoi An and buzzing Hanoi streets — Vietnam is a feast for every sense.",
    highlights: ["Halong Bay cruise", "Hoi An old town", "Ba Na Hills Golden Bridge", "Street food trails"],
    itinerary: [
      { day: 1, title: "Arrive Hanoi", desc: "Old Quarter walk and Hoan Kiem Lake." },
      { day: 2, title: "Halong Bay Cruise", desc: "Overnight luxury cruise amid limestone islands." },
      { day: 3, title: "Halong to Hanoi", desc: "Cave visit, kayaking and return to Hanoi." },
      { day: 4, title: "Fly to Da Nang", desc: "My Khe beach and Marble Mountains." },
      { day: 5, title: "Ba Na Hills", desc: "Cable car to the iconic Golden Bridge." },
      { day: 6, title: "Hoi An", desc: "Ancient town, tailor shops and lantern boat ride." },
      { day: 7, title: "Leisure", desc: "Beach relaxation and shopping." },
      { day: 8, title: "Departure", desc: "Transfer to airport." },
    ],
  },
  {
    slug: "peaceful-nepal",
    title: "Peaceful Nepal",
    subtitle: "Kathmandu • Pokhara",
    region: "Himalaya",
    type: "international",
    price: 62000,
    nights: 5,
    days: 6,
    tag: "Spiritual",
    image: IMG.nepal,
    summary:
      "Ancient temples, prayer flags fluttering over Kathmandu valley and the serene lakeside of Pokhara beneath the Annapurnas.",
    highlights: ["Pashupatinath", "Phewa Lake", "Sarangkot sunrise", "Boudhanath Stupa"],
    itinerary: [
      { day: 1, title: "Arrive Kathmandu", desc: "Pashupatinath and Boudhanath evening aarti." },
      { day: 2, title: "Kathmandu Valley", desc: "Swayambhunath and Durbar Square heritage." },
      { day: 3, title: "Drive to Pokhara", desc: "Scenic drive to the lakeside town." },
      { day: 4, title: "Sarangkot", desc: "Himalayan sunrise, Davis Falls and boat ride on Phewa Lake." },
      { day: 5, title: "Return Kathmandu", desc: "Leisure and Thamel shopping." },
      { day: 6, title: "Departure", desc: "Transfer to airport." },
    ],
  },
  {
    slug: "blissful-bhutan",
    title: "Blissful Bhutan",
    subtitle: "Land of the Thunder Dragon",
    region: "Himalaya",
    type: "international",
    price: 89500,
    nights: 6,
    days: 7,
    tag: "Happiness",
    image: IMG.bhutan,
    summary:
      "The world's happiest kingdom — dzongs perched on cliffs, prayer wheels and the legendary Tiger's Nest monastery.",
    highlights: ["Tiger's Nest hike", "Punakha Dzong", "Dochula Pass", "Thimphu culture"],
    itinerary: [
      { day: 1, title: "Arrive Paro", desc: "Scenic Himalayan landing, transfer to Thimphu." },
      { day: 2, title: "Thimphu", desc: "Buddha Dordenma, memorial chorten and craft village." },
      { day: 3, title: "Thimphu to Punakha", desc: "Dochula Pass and the grand Punakha Dzong." },
      { day: 4, title: "Punakha to Paro", desc: "Suspension bridge and return to Paro." },
      { day: 5, title: "Tiger's Nest", desc: "Iconic hike to Taktsang Monastery." },
      { day: 6, title: "Paro Leisure", desc: "Rinpung Dzong and local markets." },
      { day: 7, title: "Departure", desc: "Transfer to airport." },
    ],
  },
  {
    slug: "serene-sri-lanka",
    title: "Serene Sri Lanka",
    subtitle: "Colombo • Kandy • Bentota",
    region: "Islands",
    type: "international",
    price: 78500,
    nights: 6,
    days: 7,
    tag: "Island",
    image: IMG.srilanka,
    summary:
      "Tea-clad hills, golden beaches and the sacred tooth relic — the pearl of the Indian Ocean welcomes you.",
    highlights: ["Temple of the Tooth", "Nuwara Eliya tea", "Bentota beaches", "Sigiriya rock"],
    itinerary: [
      { day: 1, title: "Arrive Colombo", desc: "City tour and Gangaramaya Temple." },
      { day: 2, title: "Colombo to Kandy", desc: "Pinnawala elephant orphanage enroute." },
      { day: 3, title: "Kandy", desc: "Temple of the Sacred Tooth Relic and botanical gardens." },
      { day: 4, title: "Nuwara Eliya", desc: "Tea plantations and little England charm." },
      { day: 5, title: "Bentota", desc: "Beach transfer and water sports." },
      { day: 6, title: "Bentota Leisure", desc: "Madu river safari and turtle hatchery." },
      { day: 7, title: "Departure", desc: "Transfer to airport." },
    ],
  },
  {
    slug: "kailash-mansarovar-yatra",
    title: "Kailash Mansarovar Yatra",
    subtitle: "The Sacred Pilgrimage",
    region: "Pilgrimage",
    type: "international",
    price: 195000,
    nights: 12,
    days: 13,
    tag: "Yatra",
    image: IMG.kailash,
    summary:
      "The most revered pilgrimage on earth — the parikrama of Mount Kailash and a holy dip in the divine Mansarovar lake.",
    highlights: ["Mansarovar lake", "Kailash parikrama", "Dolma La Pass", "Guided spiritual support"],
    itinerary: [
      { day: 1, title: "Kathmandu Assembly", desc: "Briefing, permits and preparation." },
      { day: 2, title: "Drive to Border", desc: "Journey towards the Tibet frontier." },
      { day: 3, title: "Acclimatisation", desc: "Rest and altitude adjustment at Saga." },
      { day: 4, title: "To Mansarovar", desc: "First darshan of Holy Lake and Mount Kailash." },
      { day: 5, title: "Mansarovar Parikrama", desc: "Holy dip and puja on the lake shore." },
      { day: 6, title: "Kailash Parikrama Begins", desc: "Trek to Dirapuk." },
      { day: 7, title: "Dolma La Pass", desc: "The most sacred and challenging leg of the parikrama." },
      { day: 8, title: "Complete Parikrama", desc: "Return leg to Darchen." },
      { day: 9, title: "Return Journey", desc: "Drive back towards Saga." },
      { day: 10, title: "To Border", desc: "Continue towards Nepal." },
      { day: 11, title: "To Kathmandu", desc: "Return to Kathmandu." },
      { day: 12, title: "Kathmandu Rest", desc: "Leisure and thanksgiving." },
      { day: 13, title: "Departure", desc: "Transfer to airport." },
    ],
  },
  {
    slug: "char-dham-yatra",
    title: "Char Dham Yatra",
    subtitle: "Yamunotri • Gangotri • Kedarnath • Badrinath",
    region: "Pilgrimage",
    type: "domestic",
    price: 58500,
    nights: 10,
    days: 11,
    tag: "Yatra",
    image: IMG.chardham,
    summary:
      "The four sacred abodes of the Himalayas — a soul-stirring pilgrimage through Uttarakhand's holiest shrines.",
    highlights: ["Kedarnath darshan", "Badrinath temple", "Gangotri", "Yamunotri"],
    itinerary: [
      { day: 1, title: "Arrive Haridwar", desc: "Evening Ganga aarti at Har Ki Pauri." },
      { day: 2, title: "To Barkot", desc: "Drive via Mussoorie hills." },
      { day: 3, title: "Yamunotri", desc: "Trek to the source shrine of Yamuna." },
      { day: 4, title: "To Uttarkashi", desc: "Enroute Vishwanath temple." },
      { day: 5, title: "Gangotri", desc: "Darshan at the origin of the Ganges." },
      { day: 6, title: "To Guptkashi", desc: "Scenic Himalayan drive." },
      { day: 7, title: "Kedarnath", desc: "Trek / heli to the sacred Jyotirlinga." },
      { day: 8, title: "To Badrinath", desc: "Drive to the abode of Vishnu." },
      { day: 9, title: "Badrinath & Mana", desc: "Darshan and India's last village." },
      { day: 10, title: "Return", desc: "Drive back to Rishikesh." },
      { day: 11, title: "Departure", desc: "Transfer onward." },
    ],
  },
];

export function getPackage(slug) {
  return PACKAGES.map((p) => ({ ...p, inclusions: defaultInc, exclusions: defaultExc })).find(
    (p) => p.slug === slug
  );
}

export const SERVICES = [
  { icon: "Plane", title: "Ticketing", desc: "Domestic & international air, rail and bus ticketing at the best fares." },
  { icon: "BookMarked", title: "Passport Assistance", desc: "End-to-end guidance for new passports, renewals and documentation." },
  { icon: "StampIcon", title: "Visa Assistance", desc: "Hassle-free visa processing for 40+ countries with expert support." },
  { icon: "Car", title: "Car Rental Services", desc: "Where it all began in 1991 — a reliable fleet for every occasion." },
  { icon: "Building2", title: "MICE & Corporate Events", desc: "Meetings, incentives, conferences and events, flawlessly managed." },
  { icon: "Sprout", title: "Farmers' Study Tours", desc: "Government-approved agricultural study tours to Israel since 2018." },
];

export const WHY_US = [
  { icon: "BadgeIndianRupee", title: "Competitive Pricing", desc: "Direct contracts and 3 decades of relationships mean honest, best-value pricing." },
  { icon: "Globe2", title: "Worldwide Coverage", desc: "From the Himalayas to the Mediterranean — 40+ destinations on your list." },
  { icon: "Zap", title: "Fast Booking", desc: "Quick confirmations and a dedicated relationship manager for every trip." },
  { icon: "Users", title: "Guided Tours", desc: "Experienced tour managers and trusted local guides on every departure." },
  { icon: "Award", title: "35+ Years Experience", desc: "A trusted family-run legacy serving 3000+ travellers every single year." },
  { icon: "Route", title: "Personalized Itineraries", desc: "Tailor-made journeys crafted around your pace, taste and budget." },
];

export const REVIEWS_SUMMARY = {
  rating: 4.9,
  count: 193,
  source: "Google Reviews",
  url: "https://www.google.com/search?q=Life+Line+Tours+%26+Travels+Pvt.Ltd+Reviews",
  writeUrl: "https://www.google.com/maps?cid=15445092685740387977&hl=en&reviews=1",
  mapsUrl: "https://www.google.com/maps?cid=15445092685740387977",
};

export const TESTIMONIALS = [
  { name: "Chirayu Dudhade", trip: "Verified Google Review", rating: 5, quote: "Excellent staff and excellent work ethics. Every detail of our trip was handled professionally and with genuine care — exactly what you hope for from a travel company you can trust." },
  { name: "Kalyani Harpude", trip: "Verified Google Review", rating: 5, quote: "A wonderfully organised holiday from start to finish. The team was responsive, warm and thorough. I will definitely be recommending Life Line to all my friends and family." },
  { name: "Anil & Sunita Deshpande", trip: "Majestic Rajasthan", rating: 5, quote: "From the first phone call to the last day, everything was handled with such warmth. The Hendre family treats you like their own. A truly memorable Rajasthan tour." },
  { name: "Dr. Priya Kulkarni", trip: "Essence of Vietnam", rating: 5, quote: "Beautifully planned itinerary, excellent hotels and a tour manager who anticipated our every need. Life Line has earned a customer for life." },
  { name: "Rajesh Patil", trip: "Farmers' Study Tour, Israel", rating: 5, quote: "The agricultural study tour to Israel was eye-opening and impeccably organised — permits, visas and logistics all taken care of. A genuinely professional and knowledgeable team." },
];

export const FAQS = [
  { q: "How do I book a tour with Life Line?", a: "Simply submit an enquiry through any package page or call us at +91 98909 16767. Our travel expert will call you back with a customised quote and itinerary." },
  { q: "Do you customise itineraries?", a: "Absolutely. Every itinerary can be tailored to your dates, budget, group size and interests. Personalised journeys are our specialty." },
  { q: "What is included in the tour price?", a: "Most packages include accommodation, daily meals as specified, private transport, sightseeing, entry tickets and a tour manager. Each package page lists exact inclusions and exclusions." },
  { q: "Do you help with passports and visas?", a: "Yes. As a one-stop travel solution we provide complete passport and visa assistance for 40+ countries." },
  { q: "What are the Farmers' Study Tours?", a: "Since 2018 we have operated government-approved agricultural study tours, notably to Israel, helping farmers learn modern farming techniques abroad." },
  { q: "How much advance payment is required?", a: "Typically a booking amount confirms your reservation, with the balance payable before departure. Exact terms are shared with your quotation." },
  { q: "Do you handle corporate and group travel?", a: "Yes, our dedicated MICE division manages corporate offsites, incentive trips, conferences and large group departures end-to-end." },
];

export const TIMELINE = [
  { year: "1991", title: "The Beginning", desc: "Mr. Jeevan Hendre & Mrs. Rekha Hendre start Life Line as a trusted car rental company in Pune." },
  { year: "2000s", title: "Full-Service Travel", desc: "Expansion into ticketing, passport & visa assistance and domestic tour packages." },
  { year: "2010s", title: "Going Global", desc: "International tours, MICE and corporate events added — serving thousands of travellers annually." },
  { year: "2018", title: "Farmers' Study Tours", desc: "Awarded government-approved agricultural study tours to Israel." },
  { year: "Today", title: "A Trusted Legacy", desc: "35+ years, 3000+ travellers a year, and a second generation carrying the family promise forward." },
];

export const IMAGES = IMG;

export const TRAVEL_QUOTES = [
  "\u201CTravel is the only thing you buy that makes you richer.\u201D",
  "\u201CThe world is a book, and those who do not travel read only one page.\u201D",
  "\u201CJobs fill your pocket, but adventures fill your soul.\u201D",
  "\u201CTo travel is to live.\u201D — Hans Christian Andersen",
  "\u201CCollect moments, not things.\u201D",
  "\u201CAdventure awaits — pack your bags.\u201D",
];

